export const localeNames = [
  'Home_local',
  'About_local',
  'Clause_local',
  'Detail_local',
  'Help_local',
  'Home_local',
  'News_local',
  'Tracking_local',
  'Product_local'
];
export const locale = {
  'zh-CN': {
    global: {
      //头部
      empty:'暂无内容',
      cnSite:'中国站',
      jpSite:'日本ウェブサイト',
      Home: '首页',
      News: '企业资讯',
      RecentActivities:'最新活动',
      CompanyNews:'公司资讯',
      Tracking: "自助查询",
      TrackingC:'自助查询',
      STracking:'运单查询',
      PCoverage:'全国揽收范围查询',
      PPricing:'价格/时效查询',
      PSpecifications:'重量/尺寸/货值限制查询',
      Contrabands:'禁运产品查询',
      Products: '产品与服务',
      Help: '帮助中心',
      BInquiries:'业务咨询',
      UserManua:'新手教程',
      FAQ:'常见问题',
      About: '关于橙联',
      CInformation:'橙联公司介绍',
      COpportunities:'人才招聘',
      ContactUs:'联系我们',
      Login: '登录/注册',
      SPKLogin:'SpeedPAK登录/注册',
      MCLogin:'Multi-Channel登录/注册',
      //尾部
      ServiceDisclaimer:'使用声明',
      PrivacyDisclaimer:'隐私政策',
      TermsConditions:'通用条款',
      SpeedPAK:'海外直邮服务',
      consolFre:'海外仓头程服务',
      // speed
      Tel:'电话：',
      TelCN:'400 126 0008 / 86 21 60662670（中国大陆）',
      TelHK:'852 30183458（香港地区）',
      workTime:'工作时间：周一至周六 9:00-18:00（周日节假日除外）',
      Mail:'邮箱：CS@orangeconnex.com',
      CopyRight:'橙联（中国）有限公司  版权所有  ',
      Wechat:'微信公众号：橙联中国',
      //--cf--
      cfTelCN:'86 21 32107642/ 86 21 32107646（中国大陆）',
      mcTelCN:'86 21 32107646/ 86 21 32107713（中国大陆）',
      cfMail:'邮箱：Speedfreight@orangeconnex.com',
      //--------------------------------------------------------
      placeholder:'请输入要查询的物流单号，每行一个，最多20行。',
      orangeConnex:'OCL橙联',
      speedPAK:'SpeedPAK查询',
      oclTrack:'物流单号查询',
      language: '语言',
      trackingNo:'物流单号',
      button: {
        back:'返回首页',
        track:'轨迹查询',
        next: '下一个',
        detail:'详情'
      },
      table: {
        loadingText: '拼命加载中...',
        emptyText: '暂无数据',
        index: '序号',
        summaryText: '合计',
        showTotal: '显 示 {0} 条,共 搜 索 到 {1} 条'
      },
      loading:'加载中',
      description:'暂无查询结果，请确认输入的物流单号是否正确',
      notFound:'暂无查询结果，请确认输入的物流单号是否正确',
      errorMessage:'请输入运单跟踪号!',
      errorMessage2:'请输入正确的运单跟踪号!',
      select: '请选择',
    },
  },
  'en-US': {
    global: {
      //头部
      empty:'Empty Content',
      cnSite:'中国站',
      jpSite:'日本ウェブサイト',
      Home: 'Home',
      News: 'News',
      RecentActivities:'Recent Activities',
      CompanyNews:'Company News',
      Tracking: "Tracking",
      TrackingC:'Searching and Tracking',
      STracking:'Shipment Tracking',
      PCoverage:'Pick-up Service Coverage',
      PPricing:'Products and Pricing',
      PSpecifications:'Package Specifications',
      Contrabands:'Contrabands',
      Products: 'Products & Services',
      About: 'About Us',
      CInformation:'Company Information',
      COpportunities:'Career Opportunities',
      ContactUs:'Contact Us',
      Help: 'Help Center',
      BInquiries:'Business Inquiries',
      UserManua:'User Manual',
      FAQ:'FAQ',
      Login: 'Login/registration',
      SPKLogin: 'SpeedPAK Login/registration',
      MCLogin:'Multi-Channel Login/regist',
      //尾部
      ServiceDisclaimer:'Service Disclaimer',
      PrivacyDisclaimer:'Privacy Disclaimer',
      TermsConditions:'Terms and Conditions',
      SpeedPAK:'SpeedPAK Service',
      consolFre:'Speed Freight Service',
      //speek
      Tel:'Tel:',
      TelCN:'400 126 0008 / 86 21 60662670(China mainland)',
      TelHK:'852 30183458(HKSAR)',
      workTime:'Business Hours: Monday to Saturday 9:00-18:00（Sunday and National Holiday: Closed）',
      Mail:'E-Mail: CS@orangeconnex.com',
      CopyRight:'Orange Connex(China) Limited, All rights reserved.  ',
      Wechat:'Wechat：橙联中国',
      //cf
      cfTelCN:'86 21 32107642/ 86 21 32107646（China mainland）',
      mcTelCN:'86 21 32107646/ 86 21 32107713（China mainland）',
      cfMail:'E-Mail: Speedfreight@orangeconnex.com',
      //-----------------------------------------------
      placeholder: 'Track up to 20 packages. Each tracking number should be in their own line' ,
      orangeConnex: 'ORANGE CONNEX',
      speedPAK: 'Tracking For SpeedPAK',
      language: 'language',
      trackingNo:'Tracking No.',
      oclTrack:'Track And Trace',
      button: {
        back:'Home',
        track: 'Track',
        next: 'NEXT',
        detail:'Details'
      },
      table: {
        loadingText: 'Loading...',
        emptyText: 'No Data',
        index: 'Idx',
        summaryText: 'Total',
        showTotal: 'Showing {0}, Total {1} Searched'
      },
      loading:'Loading',
      description:'No record found. Please confirm that you have typed correct tracking No. and try again.',
      notFound: 'No record found. Please confirm that you have typed correct tracking No. and try again.',
      errorMessage:'Please enter the waybill tracking number!',
      errorMessage2:'Please enter the correct waybill tracking number!',
      select:'Select'
    }
    }
  }




// WEBPACK FOOTER //
// ./src/assets/i18n/locale.js